export default "__VITE_ASSET__EUO4aKll__"